import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import "moment/locale/es";

const TimestampFormat = props => {
  const { lang } = props

  function formatDate(date) {
    if(props.type==="date"){
      return <>{moment(date).locale(lang).format("LL")}</>
    }else if(props.type==="full-date"){
      return <>{moment(date).locale(lang).format("LL HH:mm:ss")}</>
    }
    else{
      return <>{moment(date).locale(lang).fromNow()}</>
    }
  }

  return (
    <>{formatDate(props.date)}</>
  )
}

const mapStateToProps = ({ i18n }) => ({ lang: i18n.lang })
const mapDispatchToProps = {}
export default connect(mapStateToProps, mapDispatchToProps)(TimestampFormat)

